module.exports = __webpack_public_path__ + "static/media/ic_conduite_grue_white.04032bc9.svg";